import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-replaces-parts',
  templateUrl: './replaces-parts.component.html',
  styleUrls: ['./replaces-parts.component.scss']
})
export class ReplacesPartsComponent {
  @Input() replacedParts: string[] = [];
}
